import React, { Component } from "react";
import styled from "styled-components";
import { TableDefault, mapMetric, LabelString } from "@loanbossinc/component-library";

const StyledDefaultTable = styled(TableDefault)`
  && {
    border: 1px solid #DADCE0;
    border-radius: 8px;

    thead {
      display: none;
    }

    tr { 
      background: #FFF !important;
      height: 56px;

      &:first-child {
        border-top: none;

        td {
          border-top: none;
        }
      }

      &:last-child {
        border-bottom: none;

        td {
          border-bottom: none;
        }
      }

      &:not(:first-child):not(:last-child) {
        border-top: 1px solid #DADCE0;
      }
    }

    .cell-metric-name > span {
      font-family: Work Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      text-transform: uppercase;
      color: #5F6368;
    }

    .cell-metric > span {
      font-family: "Space Mono";
      color: rgb(0, 0, 0);
      font-size: 14px;
    }
  }
`;

export class DealMetricTable extends Component {
  mapColumns = () => {
    return [
      {
        id: 'metric-name'
        , label: 'METRIC'
        , path: 'name'
        , Cell: (value) => <LabelString value={value} />
      }
      , {
        id: 'metric'
        , label: 'CURRENT BALANCE'
        , path: 'metric'
        , Cell: (value) => {
          const formattedMetric = mapMetric(value);
          return <LabelString value={formattedMetric} />
        }
      }
    ]
  }

  mapData = () => {
    const { metrics } = this.props;
    return metrics.reduce((acc, cur) => {
      acc.push({ name: cur.screen_element.title, metric: cur });
      return acc;
    }, []);
  }

  render() {
    const { metrics } = this.props;
    if (!metrics) return null;

    return (
      <StyledDefaultTable
        elevation={0}
        hideHeader={true}
        columns={this.mapColumns()}
        items={this.mapData()} />
    );
  }
}
